import { FlexContainer, Icon, IconName, Label } from '@facephi/ui-react';
import { useTranslation } from 'react-i18next';
import { StyledDetailError } from './Styles';
import {
  ErrorLiteralType,
  OperationReasonsTexts,
  OperationResultReasonTypes,
} from '../../../state/model/operations';

const getIcon = (message: string): IconName => {
  if (message.includes(OperationResultReasonTypes.timeout)) {
    return 'HourglassLow';
  } else if (message.includes(OperationResultReasonTypes.cancelByUser)) {
    return 'XCircle';
  } else if (message.includes(OperationResultReasonTypes.notPassed)) {
    return 'UserSquare';
  } else if (message.includes(OperationResultReasonTypes.alreadyRegistered)) {
    return 'SmileySad';
  } else if (message.includes(OperationResultReasonTypes.expiredByScheduler)) {
    return 'CalendarX';
  } else if (message.includes(OperationResultReasonTypes.manualStatusChange)) {
    return 'ArrowsLeftRight';
  } else {
    return 'Warning';
  }
};

const getTexts = (error: string): ErrorLiteralType =>
  OperationReasonsTexts[error];

export const DetailError = ({ error }: { error: string }) => {
  console.log('getTexts', getTexts(error), error);
  const { t } = useTranslation();
  const { title, description } = getTexts(error) || {};
  return (
    <StyledDetailError columnGap="0.8">
      <Icon
        iconName={getIcon(error)}
        size="24"
        color="error400"
        weight="light"
      />
      <FlexContainer rowGap="0.8" flexDirection="column">
        <Label fontSize="14" semibold color="error400">
          {t(title || error)}
        </Label>
        {description && <Label fontSize="12">{t(description)}</Label>}
      </FlexContainer>
    </StyledDetailError>
  );
};
